import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

export const getFieldsBySection = async (sectionId) => {
  const response = await axiosClient.get(`/api/admin/sections/${sectionId}/fields`);
  return unwrapApiResponse(response);
};

export const createField = async (sectionId, payload) => {
  const response = await axiosClient.post(`/api/admin/sections/${sectionId}/fields`, payload);
  return unwrapApiResponse(response);
};

export const updateField = async (fieldId, payload) => {
  const response = await axiosClient.put(`/api/admin/fields/${fieldId}`, payload);
  return unwrapApiResponse(response);
};

export const deleteField = async (fieldId) => {
  const response = await axiosClient.delete(`/api/admin/fields/${fieldId}`);
  return unwrapApiResponse(response);
};
